const degrees = [
  {
    school: 'University of New South Wales',
    degree: 'BSc (Computer Science)',
    link: 'https://www.unsw.edu.au',
  },
  {
    school: 'University of New South Wales',
    degree: 'LLB (Bachelor of Laws)',
    link: 'https://www.unsw.edu.au',
  },
  {
    school: 'Bucerius Law School',
    degree: 'International and Comparative Law Exchange',
    link: 'https://www.law-school.de/international/',
  },
];

export default degrees;
